import actions from "../../actions";

const initialState = {
  isOpen: false,
  data: {
    mode: 0,
    session: null,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.dashboard.reviewModal.SET_REVIEW_MODAL_OPEN:
      return {
        isOpen: action.payload.state,
        data: state.data,
      };
    case actions.dashboard.reviewModal.SET_REVIEW_MODAL_DATA:
      return {
        isOpen: true,
        data: {
          mode: action.payload.data?.mode || state.data.mode,
          session: action.payload.data?.session || state.data.session,
        },
      };
    case actions.dashboard.reviewModal.RESET_REVIEW_MODAL:
      return initialState;
    default:
      return state;
  }
};
